import PropTypes from "prop-types";
import { Container, Navbar } from "react-bootstrap";
import SiteHeaderNav from "@/ui/SiteHeaderNew/__components/SiteHeaderNav";
import SiteMobileNav from "@/ui/SiteHeaderNew/__components/SiteMobileNav";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { getRoute } from "@/getters/getRoute";
import { getGlobal } from "@/getters/getGlobal";
import { Image } from "@/ui";
import { useIsDesktop } from "@/hooks/useIsDesktop";
import { useMounted } from "@/hooks/useMounted";

export default function SiteHeaderNew({ className }) {
  const global = getGlobal();
  const company_name = global["_theme.company.name"];
  const mounted = useMounted();
  const isDesktop = useIsDesktop(1400);

  return (
    <Navbar fixed="top" collapseOnSelect expand="xxl" className={clsx(classes.header)}>
      <Container className="p-0">
        <Navbar.Brand className={clsx(classes.header__brand, "me-auto px-2 py-0")} href={getRoute("home")}>
          <Image
            img={{
              path: "_theme.company.logo",
              src: "/logo.svg",
            }}
            size="320x140"
            alt={company_name}
          />
        </Navbar.Brand>
        <Navbar.Toggle className="me-2" aria-controls="responsive-navbar-nav">
          <div>
            <span />
            <span />
            <span />
          </div>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-sm-end">
          {mounted && (
            <>
              {/* ✅ DESKTOP */}
              {isDesktop && <SiteHeaderNav />}

              {/* ✅ MOBILE */}
              {!isDesktop && <SiteMobileNav />}
            </>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

SiteHeaderNew.defaultProps = {
  className: "",
};

SiteHeaderNew.propTypes = {
  className: PropTypes.string,
};
